module.exports = __webpack_public_path__ + "static/media/md-megaphone.f1694d82.svg";